// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"771b8fb8","420":"370b83d7","437":"476c6ccd"}[chunkId] + ".chunk.js";
};